import ApiClient from ".."

// In DTOs
import BookingGetUpcomingIn from "../../dtos/in/BookingGetUpcomingIn"

// Out DTOs
import BookingGetOut from "../../dtos/out/BookingGetOut"
import BookingGetListOut from "../../dtos/out/BookingGetListOut"

export class BookingEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/booking"

  /**
   * Retrieves the next upcoming booking that matches the specifications for the request user.
   */
  async getUpcoming(payload: BookingGetUpcomingIn) {
    return this.client.get<BookingGetOut>(BookingEndpoints.BASE_URL, "/upcoming", payload)
  }

  /**
   * Retrieves a list of upcoming/ongoing paid bookings that matches the specifications for the request user.
   */
  async getUpcomingPaidList(payload: BookingGetUpcomingIn) {
    return this.client.get<BookingGetListOut>(BookingEndpoints.BASE_URL, "/upcoming-paid-list", payload)
  }

  /**
   * Cancel a booking by its Cal.com ID.
   */
  async cancel(bookingCalcomId: number) {
    return this.client.post(BookingEndpoints.BASE_URL, `/${bookingCalcomId}/cancel`, {})
  }
}
